import { apiClient } from './ticketsApi';
import { ENDPOINTS } from './endpoints';

export const fetchStaffDetailsList = async () => {
    try {
        const response = await apiClient.get(`/api${ENDPOINTS.GET_STAFF_DETAILS}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching staff details:', error.response?.data || error.message);
        throw error;
    }
};

export const createStaffDetails = async (payload) => {
    try {
        const response = await apiClient.post(`/api${ENDPOINTS.CREATE_STAFF_DETAILS}`, payload, {
            headers: { 'Content-Type': 'application/json' }
        });
        return response.data;
    } catch (error) {
        console.error('Error creating staff details:', error.response?.data || error.message);
        throw error;
    }
};

// PUT /api/StaffDetails/{id} — id is the integer StaffDetails.Id.
export const updateStaffDetails = async (id, payload) => {
    try {
        const response = await apiClient.put(`/api${ENDPOINTS.UPDATE_STAFF_DETAILS}/${id}`, payload, {
            headers: { 'Content-Type': 'application/json' }
        });
        return response.data;
    } catch (error) {
        console.error('Error updating staff details:', error.response?.data || error.message);
        throw error;
    }
};
